import React from "react";
import { BrowserSupportedContext } from "./BrowserSupportedContext";

export const useBrowserSupported = () => {
  return React.useContext(BrowserSupportedContext);
};
